import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { visualizacaoModoList } from '../../../../common/visualizacao-modo';
import { ApiError, MessageService } from '../../../../core';
import { ClienteAnaliseMercadoViewProps } from '../../adapters';
import { ClienteAnaliseMercadoFilterComponent } from '../../components/filter';
import { ClienteAnaliseMercadoPeriodicidadeFilterComponent } from '../../components/periodicidade-filter';
import { perspectivaRAP } from '../../perspectivas';
import { ClienteAnaliseMercadoRevisaoAbrirRequest, ClienteAnaliseMercadoRevisaoReabrirRequest, ClienteAnaliseMercadoRevisaoRevisarRequest, ClienteAnaliseMercadoRevisaoSearch } from '../../revisao/adapters';
import { ClienteAnaliseMercadoRevisaoAprovarModalComponent } from '../../revisao/components/aprovar-modal';
import { ClienteAnaliseMercadoRevisaoHttpService } from '../../revisao/services';
import { ClienteAnaliseMercadoViewService } from '../../services';
import { ClienteAnaliseMercadoRouterService } from '../../routes/services';
import { ClienteAnaliseMercadoQueryParams } from '../../routes/cliente-analise-mercado.params';

@Component({
    selector: 'sgt-cliente-analise-mercado-view',
    templateUrl: './cliente-analise-mercado-view.component.html',
    styleUrls: ['./cliente-analise-mercado-view.component.less']
})
export class ClienteAnaliseMercadoViewComponent implements OnInit, OnDestroy {
    // TODO: REMOVER ESTAS CONFIGS
    modo = visualizacaoModoList;
    perspectiva = perspectivaRAP;

    /** Props da view */
    props: ClienteAnaliseMercadoViewProps;
    /** Subscription para o evento das props da view */
    private propsSub$: Subscription;

    /** Component do filter */
    @ViewChild('filterComponent') filterComponent: ClienteAnaliseMercadoFilterComponent;
    /** Component do filter da periodicidade */
    @ViewChild('periodicidadeFilter') periodicidadeFilter: ClienteAnaliseMercadoPeriodicidadeFilterComponent;
    /** Modal para aprovar uma revisão */
    @ViewChild('aprovarRevisaoModal') aprovarRevisaoModal: ClienteAnaliseMercadoRevisaoAprovarModalComponent;


    constructor(private activatedRoute: ActivatedRoute,
                private messageService: MessageService,
                private clienteAnaliseMercadoViewService: ClienteAnaliseMercadoViewService,
                private clienteAnaliseMercadoRevisaoHttpService: ClienteAnaliseMercadoRevisaoHttpService,
                private clienteAnaliseMercadoRouterService: ClienteAnaliseMercadoRouterService) { }

    ngOnInit(): void {
        this.initSubscriptions();
        this.setQueryParams();
    }

    /** Inicia as subscriptions nos eventos da view */
    private initSubscriptions() {
        // Props
        this.propsSub$ = this.clienteAnaliseMercadoViewService.props$.subscribe(props => this.props = props);
    }

    /** Seta as querys params do router */
    private setQueryParams() {
        // Obtendo as querys params do router
        const queryParams = this.clienteAnaliseMercadoRouterService.getQueryParams(this.activatedRoute);
        // Setando nas props da view
        this.clienteAnaliseMercadoViewService.setQueryParams(queryParams);
    }

    private setStorage() {
        // Filter
        this.filterComponent?.setStorage();
    }

    /** Quando o filtro for inicializado */
    async onFilterInitialized() {
        // Iniciando a periodicidade
        await this.periodicidadeFilter?.initPeriodicidade();
        // Setando a revisão das Análises de Mercado
        await this.clienteAnaliseMercadoViewService.setRevisao(this.periodicidadeFilter.getAno(), this.filterComponent.getIdsRepresentante());
        // Setando o representante da revisão
        this.clienteAnaliseMercadoViewService.setRepresentanteRevisao();
        // Realizando a pesquisa das análises
        this.load();
    }

    /** Ao alterar algum valor do filtro */
    onFilterChange() {
        // Realizando a pesquisa das análises
        this.load();
    }

    /** Ao limpar o filtro */
    async onFilterClear() {
        // Setando a revisão das Análises de Mercado
        await this.clienteAnaliseMercadoViewService.setRevisao(this.periodicidadeFilter.getAno(), this.filterComponent.getIdsRepresentante());
        // Setando o representante da revisão
        this.clienteAnaliseMercadoViewService.setRepresentanteRevisao();
        // Realizando a pesquisa das análises
        this.load();
    }

    /** Ao alterar o filtro da data da periodicidade */
    onPeriodicidadeDataChange() {
        // Setando a revisão das Análises de Mercado
        this.clienteAnaliseMercadoViewService.setRevisao(this.periodicidadeFilter.getAno(), this.filterComponent.getIdsRepresentante());
        // Realizando a pesquisa das análises
        this.load();
    }

    /** Ao alterar o filtro dos representantes */
    async onFilterRepresentantesChange() {
        // Setando a revisão das Análises de Mercado
        await this.clienteAnaliseMercadoViewService.setRevisao(this.periodicidadeFilter.getAno(), this.filterComponent.getIdsRepresentante());
        // Setando o representante da revisão
        this.clienteAnaliseMercadoViewService.setRepresentanteRevisao();
        // Realizando a pesquisa das análises
        this.load();
    }

    load() {
        if (!this.filterComponent?.filter.possuiAno()) {
            this.messageService.info('Para consultar as Análises de Mercado é necessário selecionar o ano', 'Informação');
            this.periodicidadeFilter?.setFocus();
            return false;
        }
        // Setando o storage
        this.setStorage();
        // Executando o load
        this.clienteAnaliseMercadoViewService.execLoad(this.filterComponent.filter);
    }

    /** Exibir as informações das revisões anual das Análises de Mercado de um representante */
    showInfosRevisoes() {
        window.alert('Funcionalidade de histórico de revisões em desenvolvimento. Aguarde!');
    }

    /** Abre uma nova revisão anual das Análises de Mercado de um representante */
    async abrirRevisao() {
        const result = await this.messageService.confirm(`Deseja realmente abrir uma nova revisão das Análises de Mercado em ${this.props.anoRevisao}?`, 'Confirme')
        if (result) {
            const req = new ClienteAnaliseMercadoRevisaoAbrirRequest(this.props.anoRevisao, this.props.idRepresentanteRevisao)
            this.clienteAnaliseMercadoRevisaoHttpService.abrir(req)
                .pipe(take(1))
                .subscribe(
                    entity => {
                        this.clienteAnaliseMercadoViewService.setRevisaoAtual(entity);
                        this.revisar();
                        this.messageService.success('', 'Nova Revisão Aberta com Sucesso');
                    },
                    (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                );
        }
    }

    /** Reabre uma revisão anual das Análises de Mercado de um representante */
    async reabrirRevisao() {
        const result = await this.messageService.confirm(`Deseja realmente reabrir a revisão das Análises de Mercado em ${this.props.anoRevisao}?`, 'Confirme')
        if (result) {
            const req = new ClienteAnaliseMercadoRevisaoReabrirRequest(this.props.anoRevisao, this.props.idRepresentanteRevisao)
            this.clienteAnaliseMercadoRevisaoHttpService.reabrir(req)
                .pipe(take(1))
                .subscribe(
                    entity => {
                        this.clienteAnaliseMercadoViewService.setRevisaoAtual(entity);
                        this.messageService.success('', 'Revisão Reaberta com Sucesso');
                    },
                    (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                );
        }
    }

    /** Revisa as Análises de Mercado anuais de um representante */
    async revisar() {
        // Sempre setando para periodicidade anual para garantir que os dados sejam anuais
        await this.periodicidadeFilter.setPeriodicidadeAnual();

        // Iniciando revisão das Análises de Mercado
        const req = new ClienteAnaliseMercadoRevisaoRevisarRequest(this.props.anoRevisao, this.props.idRepresentanteRevisao)
        this.clienteAnaliseMercadoRevisaoHttpService.revisar(req)
            .pipe(take(1))
            .subscribe(
                entity => {
                    this.clienteAnaliseMercadoViewService.setRevisaoAtual(entity);
                    this.clienteAnaliseMercadoViewService.setRevisaoMode(true);
                },
                (error: ApiError) => this.messageService.error(error.message, error.cause, error)
            );
    }

    /** Confirma as alterações na revisão */
    confirmarRevisao() {
        this.clienteAnaliseMercadoViewService.setRevisaoMode(false);
    }

    /** Aprova uma revisão anual das Análises de Mercado de um representante */
    aprovarRevisao() {
        this.aprovarRevisaoModal.open(this.props.anoRevisao, this.props.idRepresentanteRevisao);
    }

    /** Após aprovar a revisão anual das Análises de Mercado de um representante */
    afterAprovarRevisao(entity: ClienteAnaliseMercadoRevisaoSearch) {
        this.clienteAnaliseMercadoViewService.setRevisaoAtual(entity);
    }

    /** Realiza os unsubscribes nos eventos da view */
    private destroySubscriptions() {
        // Props
        this.propsSub$.unsubscribe();
    }

    back() {
        this.clienteAnaliseMercadoRouterService.back();
    }

    ngOnDestroy(): void {
        this.destroySubscriptions();
    }
}
